import { IDI_INSPECTOR_DETAIL_SEARCH_START_LOADING, IDI_INSPECTOR_DETAIL_SEARCH_END_LOADING, IDI_INSPECTOR_DETAIL_SEARCH_LOADED, SET_IDI_INSPECTOR_DETAIL_FILTER } from "../constants/IdiInspectorDetailConstants";
import { IDI_INSPECTOR_DETAIL_START_LOADING, IDI_INSPECTOR_DETAIL_END_LOADING, IDI_INSPECTOR_DETAIL_LOADED } from "../constants/IdiInspectorDetailConstants";

import { getApiData, postApiJsonData } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadIdiInspectorDetailSearch(filters, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_INSPECTOR_DETAIL_SEARCH_START_LOADING });

        try {

            var data = await postApiJsonData("IdiInspectorDetail/GetPaged", filters, null);
            
            if(data.success) {
                await dispatch({
                    type: IDI_INSPECTOR_DETAIL_SEARCH_LOADED,
                    payload: {
                        dataList: data.responseEntities[0].dataList
                        , searchList: data.responseEntities[0].userSearches
                        , totalCount: data.responseEntities[0].totalCount
                    }
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: IDI_INSPECTOR_DETAIL_SEARCH_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_INSPECTOR_DETAIL_SEARCH_END_LOADING });
        }
    };
}

export function setIdiInspectorDetailFilter(filter) {
    return async (dispatch) => {
        await dispatch({
            type: SET_IDI_INSPECTOR_DETAIL_FILTER,
            payload: filter
        });
    };
}

export function loadIdiInspectorDetail(id, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_INSPECTOR_DETAIL_START_LOADING });

        try {

            var data = await getApiData("IdiInspectorDetail/GetIdiInspectorDetailFBO", { id });
            
            if(data.success) {
                await dispatch({
                    type: IDI_INSPECTOR_DETAIL_LOADED,
                    payload: data.responseEntities[0]
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: IDI_INSPECTOR_DETAIL_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_INSPECTOR_DETAIL_END_LOADING });
        }
    };
}

export function saveIdiInspectorDetail(fbo, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_INSPECTOR_DETAIL_START_LOADING });

        try {

            var isAdd = fbo.isAddMode;
            var data = await postApiJsonData("IdiInspectorDetail/SaveIdiInspectorDetailFBO", null, fbo);
            
            if(data.success) {
                await dispatch({
                    type: IDI_INSPECTOR_DETAIL_LOADED,
                    payload: data.responseEntities[0]
                });
                
                dispatch(commonActions.setSuccessMessage("IDI Inspector Saved Successfully!"));
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: IDI_INSPECTOR_DETAIL_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_INSPECTOR_DETAIL_END_LOADING });
        }
    };
}

export async function resolveGoogleMapLink(url) {
    var objReturn = {
        latitude: 0,
        longitude: 0,
        error: null
    };
    
    try {

        var data = await getApiData("IdiInspectorDetail/ResolveGoogleMapLink", { url });
        
        if(data.success) {
            objReturn.latitude = data.responseEntities[0].latitude;
            objReturn.longitude = data.responseEntities[0].longitude;
        }
        else {
            objReturn.error = data.errorDesc;
        }
    } 
    catch (error) {
        objReturn.error = error;
    }

    return objReturn;
}